import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { IConsortium, IConsortiumCriteria, IConsortiumDestination } from '../../consortium/consortium.interface';
import { IVesselCriteria } from '../../vessel/vessel.interface';
import { IVesselVoyage } from '../vessel-voyage-interface';

@Component({
    selector: 'app-vessel-voyage-form',
    templateUrl: './vessel-voyage-form.component.html',
    styleUrls: ['./vessel-voyage-form.component.less'],
    standalone: false
})
export class VesselVoyageFormComponent implements OnInit {

  vesselVoyageForm: FormGroup;
  vesselCriteria:IVesselCriteria={};
  vesselList:any;
  consortiums:any;
  lines:any;
  consortiumCriteria:IConsortiumCriteria={};
  portList:any;
  disableSubmit:boolean=false;
  formattedDate:Date;
  editPermission:boolean=false;
  addPermission:boolean=false;
  searching:boolean=false;
  typeSearchCtrl = this.formBuilder.control('');
  onDestroy=new Subject<void>();
  filtered:ReplaySubject<IVesselVoyage[]> = new ReplaySubject<IVesselVoyage[]>(1);
  viewLog = this.formBuilder.control(false);
  consortiumSearchCtrl = this.formBuilder.control('');
  lineSearchCtrl = this.formBuilder.control('');
  filteredConsortiums:ReplaySubject<IConsortium[]> = new ReplaySubject<IConsortium[]>(1);
  filteredLines:ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  filteredPorts:ReplaySubject<IConsortiumDestination[]> = new ReplaySubject<IConsortiumDestination[]>(1);
  vesselVoyageDetail:any;
  canAddCutOff : boolean = true;
  currentDate=moment(new Date()).utc(true).toDate();

  constructor( private formBuilder:FormBuilder,private router:Router,
    private activatedRoute:ActivatedRoute,
    private service:DataService, 
    private utilityService:UtilityService,
    private dailog:MatDialog,
    private logger:NGXLogger,
    private permissionService:PermissionService) { }

  ngOnInit(): void {
    this.viewLog.setValue(false);
    this.checkAllPermission();
    this.initializeForm();
    this.filterConsortium();
    this.getFilter();
    this.getVessels();
    this.setConsortiumValueChangeEvent();
  }

  private initializeForm(){
		this.vesselVoyageForm = this.formBuilder.group({
      id:[],
      vesselId:[null,[Validators.required]],
      consortiumId:[null,[Validators.required]],
      voyageNo:[null,[Validators.required]],
      lineId:[null],
      vesselVoyagePortDetails:this.formBuilder.array([this.vesselVoyagePortDetailsForm()]),
      cutOffsDetails : this.formBuilder.array([])
		});
 	}

  public cutOffsDetailsForm(data?:any){
    let form = this.formBuilder.group({
      portId:[data?data.portId:null,[Validators.required]],
      ams:[data?data.ams:null],
      si:[data?data.si:null],
      port:[data?data.port:null],
      icdHandover:[data?data.icdHandover:null],
      docHandover:[data?data.docHandover:null],
      haz:[data?data.haz:null],
      reefer:[data?data.reefer:null],
      odc:[data?data.odc:null],
      vgm:[data?data.vgm:null],
      form13:[data?data.form13:null],
      stuffing:[data?data.stuffing:null,[Validators.required]],
      portList:[this.portList],
    })
    return form;
  }

   public vesselVoyagePortDetailsForm(data?:any):FormGroup{
    let form = this.formBuilder.group({
      portId:[data?data.portId:null,[Validators.required]],
      eta:[data?data.eta:null],
      etd:[data?data.etd:null],
      aad:[data?data.aad:null],
      asd:[data?data.asd:null],
      isOpen:[data?.isOpen !== undefined ? data.isOpen : true],
      portList:[this.portList],
      portSearch:[],
    })
    this.searchValueChangeInFormArray(form,this.filteredPorts,'portSearch','portList');
    return form;
  }

  public searchValueChangeInFormArray(form:any,observableName:any,searchControlName:any,selectListControlName:any){
    form.get(searchControlName).valueChanges.subscribe((searchText) => {
      observableName.subscribe((items) => {
        if (searchText) {
          form.get(selectListControlName).setValue(
            items.filter((item) => item?.destinationName?.toLowerCase().includes(searchText.toLowerCase())),
          );
        } else {
          form.get(selectListControlName).setValue(items);
        }
      });
    });
  }

  etaDateChangeEvent(event:any,item:any){
    let formattedEtaDate=moment(event.value).utc(true).toDate();
    item.get('eta').setValue(formattedEtaDate);
    if(item.get('etd').value<item.get('eta').value)
        item.get('etd').reset();
  }

  etdDateChangeEvent(event:any,item:any){
    let formattedEtdDate=moment(event.value).utc(true).toDate();
    item.get('etd').setValue(formattedEtdDate);
  }

  aadDateChangeEvent(event:any,item:any){
    let formattedAadDate=moment(event.value).utc(true).toDate();
    item.get('aad').setValue(formattedAadDate);
    if(item.get('asd').value<item.get('aad').value)
        item.get('asd').reset();
  }

  asdDateChangeEvent(event:any,item:any){
    let formattedAsdDate=moment(event.value).utc(true).toDate();
    item.get('asd').setValue(formattedAsdDate);
    item.get('isOpen').setValue(false);
  }

  utcDate(event:any, item:any, formControlName: any){
    let formattedDate=moment(event.value).utc(true).toDate();
    item.get(formControlName).setValue(formattedDate);
  }

  checkAsdDateCondition(item:any){
    return item.get('aad').value;
  }

  portChanged(index:number,value:any){
    let alreadySelected=_.where(this.vesselVoyagePortDetails.value,{portId:value});
    if(alreadySelected.length>1){
      this.vesselVoyagePortDetails.at(index).reset();
      this.utilityService.notifier('Port Already Selected','warning');
    }
    else{
      if(value != null){
        if(this.canAddCutOff){
          this.cutOffsDetails.push(this.cutOffsDetailsForm());
          this.canAddCutOff = false;
        }
        this.cutOffsDetails.at(index).get('portId').setValue(value);
      }
    }
  }

  getFilter() {
    this.typeSearchCtrl.valueChanges.pipe(tap(() => this.searching = true),
      takeUntil(this.onDestroy),
        debounceTime(200),
        map(value => {
          return this.vesselList.filter(group => 
            group.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
        }),
        delay(500)
      )
      .subscribe(filter => {
        this.searching = false;
        this.filtered.next(filter);
      },
      error => { this.searching = false; });
  }

  filterConsortium() {
    this.consortiumSearchCtrl.valueChanges.pipe(tap(() => this.searching = true),
      takeUntil(this.onDestroy),
        debounceTime(200),
        map(value => {
          if (!this.consortiums) { return []; }
          if(!value) { this.filteredConsortiums.next(this.consortiums); }
          return this.consortiums.filter(consortium => 
            consortium.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
        }),
        delay(500)
      )
      .subscribe(filter => {
        this.searching = false;
        this.filteredConsortiums.next(filter);
      },
      error => { this.searching = false; });
  }

  filterLines() {
    this.lineSearchCtrl.valueChanges.pipe(tap(() => this.searching = true),
      takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.lines) { return []; }
          if(!search) { this.filteredLines.next(this.lines); }
          return this.lines.filter(line => line.lineName.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filter => {
        this.searching = false;
        this.filteredLines.next(filter);
      },
      error => { this.searching = false; });
  }

  getVesselVoyageFromParam(){
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id']){
          this.id.setValue(+param['id']);
          this.getVesselVoyageById();
        }
    });
  }

  getVessels(){
    this.vesselCriteria['activeFlag.equals']=true;
    this.service.get(Api.VESSEL_FOR_DD,this.vesselCriteria).subscribe(res => {
      this.vesselList=res;
      this.filtered.next(this.vesselList);
      this.getVesselVoyageFromParam();
    });
  }

  vesselChanged(value:number){
    // this.vesselId.valueChanges.subscribe(idValue => {
      this.consortiumId.reset();
      this.resetPortDetails();
      this.setCriteriaAndGetConsortiums(value);
    // })
  }

  private setCriteriaAndGetConsortiums(idValue: any) {
    let vessel = _.findWhere(this.vesselList, { id: idValue });
    if (vessel) {
      this.consortiumCriteria.vesselName = vessel.name;
      this.getConsortiums();
    }
  }

  getConsortiums(){
    this.consortiumCriteria['activeFlag.equals']=true;
    this.service.get(Api.CONSORTIUM_FOR_DD,this.consortiumCriteria).subscribe(res => {
      if(res){
        this.consortiums=res;
        this.filteredConsortiums.next(this.consortiums);
        if(this.consortiumId.value){
          this.prepareAndSetportList(this.consortiumId.value);
          this.setCutOffDetails();
        }
      }
    });
  }

  setConsortiumValueChangeEvent(){
    this.consortiumId.valueChanges.subscribe(consortiumValue => {
       this.resetPortDetails();
       this.prepareAndSetportList(consortiumValue);
    })
  }

  private prepareAndSetportList(consortiumValue: any) {
    let consortium = _.findWhere(this.consortiums, { id: consortiumValue });
    this.portList = consortium?.destinationDetails;
    this.lines = consortium?.lineDetails;
    this.logger.info('line check ',consortium)
    this.filteredPorts.next(this.portList);
    this.filteredLines.next(this.lines);
    this.vesselVoyagePortDetails.controls.forEach(element => {
      element.get('portList').setValue(this.portList);
    })
  }

  addPortField(){
    let portForm=this.vesselVoyagePortDetailsForm();
    this.vesselVoyagePortDetails.push(portForm);
    this.canAddCutOff = true;
  }

  removePortField(index:number){
    if(this.vesselVoyagePortDetails.length==1){
      return;
    }
    this.vesselVoyagePortDetails.removeAt(index);
    this.cutOffsDetails.removeAt(index);
  }

  private resetPortDetails() {
    this.vesselVoyagePortDetails.clear();
    this.lineId.reset();
    this.vesselVoyagePortDetails.push(this.vesselVoyagePortDetailsForm());
    this.resetCutOffDetails();
  }
  
  private resetCutOffDetails(){
    this.cutOffsDetails.clear();
    this.canAddCutOff = true;
  }

  onSave(){
    this.vesselVoyageForm.markAllAsTouched();
    if(this.vesselVoyageForm.valid)
    {
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT,'save');
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG,'save');
      }  
    }
  }

  saveVesselVoyageModule(){
    this.setAllCutOffValue();
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    this.service[method](Api.VESSEL_VOYAGE,this.vesselVoyageForm.value).subscribe(res => {
      this.utilityService.notifier('Vessel Voyage Details '+message+' successfully', 'success');
      this.router.navigate([APP_ROUTES.VESSEL_VOYAGE_LIST]);
    });
  }
  
  setAllCutOffValue(){
    let form = this.vesselVoyageForm.value;
    form.vesselVoyagePortDetails.forEach( row =>{
      let cutoff = _.find(this.cutOffsDetails.value, {portId: row.portId});
      row['ams'] = cutoff.ams;
      row['si'] = cutoff.si;
      row['port'] = cutoff.port;
      row['icdHandover'] = cutoff.icdHandover;
      row['docHandover'] = cutoff.docHandover;
      row['haz'] = cutoff.haz;
      row['reefer'] = cutoff.reefer;
      row['odc'] = cutoff.odc;
      row['form13'] = cutoff.form13;
      row['vgm'] = cutoff.vgm;
      row['stuffing'] = cutoff.stuffing;
    });
  }

  onCancel(){
    if(this.vesselVoyageForm.dirty){
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT,'cancel');
    }
    else{
     this.router.navigate([APP_ROUTES.VESSEL_VOYAGE_LIST]);
    }
  }
 
  getVesselVoyageById(){
    if(this.id.value){
      this.service.get(Api.VESSEL_VOYAGE+'/'+this.id.value).subscribe(res => {
          if(res){
              this.vesselVoyageDetail=res;
              this.vesselVoyageForm.patchValue(res);
              this.vesselVoyagePortDetails.clear();
              res.vesselVoyagePortDetails.forEach(element => {
                this.vesselVoyagePortDetails.push(this.vesselVoyagePortDetailsForm(element));
              })
              this.setCriteriaAndGetConsortiums(this.vesselVoyageDetail.vesselId);
          }
      });
    }
  }

  private setCutOffDetails(){
    this.vesselVoyageDetail.vesselVoyagePortDetails.forEach(element => {
      this.cutOffsDetails.push(this.cutOffsDetailsForm(element));
    });
  }

  private openDailog(message?:string,mode?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(mode=='cancel') {
            this.router.navigate([APP_ROUTES.VESSEL_VOYAGE_LIST]);
          }
          else{
           this.saveVesselVoyageModule();
          }
        }
    })
  }



  getSaveBtnCondition(){
    if((!this.editPermission && this.id.value) || (!this.addPermission && !this.id.value) || !this.vesselVoyageForm.dirty){
      return false;
    }
    return true;
  }

  clearAsdDate(item: AbstractControl) {
    const asdControl = item.get('asd');
    if (!asdControl.value) {
      return;
    }
    const wasUnsaved = asdControl.dirty;
    if (this.id?.value) {
      const dialogRef = this.dailog.open(ConfirmDailogueComponent, {
        data: Message.CLEAR_DATE
      });
      dialogRef.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          asdControl.setValue(null);
          item.get('isOpen').setValue(true);
          if (wasUnsaved) {
            asdControl.markAsPristine();
            item.get('isOpen').markAsPristine();
          } else {
            this.vesselVoyageForm.markAsDirty();
          }
        }
      });
    } else {
      asdControl.setValue(null);
      asdControl.markAsPristine();
      item.get('isOpen').setValue(true);
      item.get('isOpen').markAsPristine();
    }
  }

  clearDate(control: AbstractControl) {
    if (!control.value) {
      return;
    }
    if (this.id?.value) {
      const dialogRef = this.dailog.open(ConfirmDailogueComponent, {
        data: Message.CLEAR_DATE
      });

      dialogRef.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          control.setValue(null);
          this.vesselVoyageForm.markAsDirty();
        }
      });
    } else {
      control.setValue(null);
    }
  }

  public checkAllPermission(){
    let permissionCodes=[PermissionKey.VESSEL_VOYAGE_MODULE_EDIT_PERMISSION,PermissionKey.VESSEL_VOYAGE_MODULE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VESSEL_VOYAGE_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_VOYAGE_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_VOYAGE_MODULE_ADD_PERMISSION})?.show?true:false;
  }

  get id(){ return this.vesselVoyageForm.get('id') };
  get lineId(){ return this.vesselVoyageForm.get('lineId') };
  get vesselId(){ return this.vesselVoyageForm.get('vesselId') };
  get consortiumId(){ return this.vesselVoyageForm.get('consortiumId') };
  get voyageNo(){ return this.vesselVoyageForm.get('voyageNo') };
  get vesselVoyagePortDetails(){ return (<FormArray>this.vesselVoyageForm.get('vesselVoyagePortDetails')); }
  get cutOffsDetails(){return (<FormArray>this.vesselVoyageForm.get('cutOffsDetails')); }
}
